import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import EditIcon from "@mui/icons-material/Edit";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Modal,
  Pagination,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import {
  cancelDoctorOrder,
  deleteOrder,
  deliverDoctorOrder,
  getAllOrdersByStatus,
  getDoctorOrderDetails,
  getOrdersByDate,
  shipDoctorOrder,
  updateDoctorOrderTrake,
} from "../../../store/order/orderSlice";
import { useEffect } from "react";
// import "./supcategories.scss";
import { useParams } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useFormik } from "formik";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import Swal from "sweetalert2";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65vw",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: "8px",
  boxShadow: 24,
  // p: 4,
};

function OrderList() {
  const { orders, orderDetails } = useSelector((state) => state.orderSlice);
  const dispatch = useDispatch();
  const [orderStatus, setOrderStatus] = useState("pending");
  const [orderType, setOrderType] = useState("doctor");
  const [startDate, setStartDate] = useState(
    dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
  );
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [open, setOpen] = React.useState(false);
  const [openShip, setOpenShip] = React.useState(false);
  const [selectedOrderIdToShip, setSelectedOrderIdToShip] = useState();
  const [page, setpage] = useState(1);
  const [updateTrack, setUpdateTrack] = useState(1);

  const handleOpenDetails = (id) => {
    dispatch(getDoctorOrderDetails(id)).then(() => setOpen(true));
    setUpdateTrack(true);
  };
  const handleCloseDetails = () => {
    setOpen(false);
    setUpdateTrack(false);
  };

  const handleCloseShip = () => setOpenShip(false);

  const formateDate = (MaterialDate) => {
    return `${MaterialDate.$M + 1}-${MaterialDate.$D}-${MaterialDate.$y}`;
  };

  const onDateSearch = () => {
    dispatch(
      getOrdersByDate({
        from: formateDate(startDate),
        to: formateDate(endDate),
        status: orderStatus,
        page: 1,
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      date: dayjs(new Date()).format("MM/DD/YY"),
      time: dayjs("12:00 PM", "HH:MM A")
    },
    onSubmit: (values) => {
      (updateTrack
        ? dispatch(
            updateDoctorOrderTrake({
              orderId: orderDetails._id,
              date: dayjs(values.date).format("MM/DD/YY"),
              time: dayjs(values.time).format("HH:MM A"),
            })
          )
        : dispatch(
            shipDoctorOrder({
              orderId: selectedOrderIdToShip,
              date: dayjs(values.date).format("MM/DD/YY"),
              time: dayjs(values.time).format("HH:MM A"),
            })
          )
      ).then((res) => {
        Swal.fire(
          'Good job!',
          'Updated successfully!',
          'success'
        )
        console.log(res);
        setOpenShip(false);
        setUpdateTrack(false);
        handleCloseDetails();
        
        if (startDate && endDate)
          dispatch(
            getOrdersByDate({
              from: formateDate(startDate),
              to: formateDate(endDate),
              status: orderStatus,
              page: page,
            })
          );
        else dispatch(getAllOrdersByStatus({ orderStatus: orderStatus }));
      });
    },
  });

  useEffect(() => {
    if (startDate && endDate)
      dispatch(
        getOrdersByDate({
          from: formateDate(startDate),
          to: formateDate(endDate),
          status: orderStatus,
          page: page,
        })
      );
    else dispatch(getAllOrdersByStatus({ orderStatus: orderStatus }));
  }, [orderStatus, page]);

  useEffect(() => {
    if (orderDetails) {
      // console.log('time:', );
      formik.setFieldValue("date", dayjs(orderDetails?.deliverInfo?.date));
      formik.setFieldValue("time", dayjs(orderDetails?.deliverInfo?.time, "HH:MM A"));
    }
  }, [orderDetails]);

  const orderStatusColorMap = {
    pending: "info",
    delivered: "success",
    cancelled: "error",
  };

  return (
    <div>
      <>
        <h2 className="text-center text-primary my-4">Orders</h2>
        <div className="">
          <>
            <Stack spacing={2}>
              <div
                style={{
                  display: "flex",
                  gap: "22px",
                  justifyContent: "center",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From"
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To"
                    value={endDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

                <Button
                  onClick={onDateSearch}
                  variant="contained"
                  color="success"
                >
                  Search
                </Button>
              </div>

              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Orders For
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={orderType}
                  onChange={(e) => setOrderType(e.target.value)}
                >
                  <FormControlLabel
                    value="doctor"
                    control={<Radio />}
                    label="Doctor"
                  />
                  <FormControlLabel
                    value="pharmacist"
                    disabled
                    control={<Radio />}
                    label="Pharmacist"
                  />
                  <FormControlLabel
                    value="All"
                    disabled
                    control={<Radio />}
                    label="All"
                  />
                </RadioGroup>
              </FormControl>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Order Status
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={orderStatus}
                  onChange={(e) => setOrderStatus(e.target.value)}
                >
                  <FormControlLabel
                    value="pending"
                    control={<Radio />}
                    label="pending"
                  />
                  <FormControlLabel
                    value="shipped"
                    control={<Radio />}
                    label="shipped"
                  />
                  <FormControlLabel
                    value="delivered"
                    control={<Radio />}
                    label="delivered"
                  />
                  <FormControlLabel
                    value="cancelled"
                    control={<Radio />}
                    label="cancelled"
                  />
                </RadioGroup>
              </FormControl>
            </Stack>

            <div className="tableContainer">
              <table className="table tableUsers table-light table-striped mx-auto mt-5 col-7 text-center ">
                <thead className="">
                  <tr>
                    <th>index</th>
                    <th>Order Status</th>
                    <th>Order Date</th>
                    <th>Payment Method</th>
                    <th>Total Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {/* ------body------- */}
                <tbody>
                  {orders?.map((order, index) => (
                    <tr key={order._id} className="rowtable">
                      <td>{index + 1}</td>
                      <td>
                        <Chip
                          label={order.orderStatus}
                          color={orderStatusColorMap[order.orderStatus]}
                        />
                      </td>
                      <td>{order.orderDate}</td>
                      <td> {order.payment.method}</td>
                      <td>{order.totalPrice}</td>
                      <td>
                        {/* <span className="btn-edite">
                          <EditIcon
                            onClick={() =>
                              dispat1ch(setEditableOrder(order))
                            }
                          />
                        </span> */}
                        {order.orderStatus === "delivered" ||
                          order.orderStatus === "cancelled" || (
                            <>
                              {order.orderStatus === "shipped" || (
                                <Tooltip title={<h5>Shipped</h5>}>
                                  <IconButton style={{ cursor: "pointer" }}>
                                    {/* deliver btn */}
                                    <LocalShippingIcon
                                      color="info"
                                      onClick={() => {
                                        setOpenShip(true);
                                        setSelectedOrderIdToShip(order._id);
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}

                              <Tooltip title={<h5>Delivered</h5>}>
                                <IconButton style={{ cursor: "pointer" }}>
                                  {/* deliver btn */}
                                  <CheckCircleIcon
                                    color="success"
                                    onClick={() =>
                                      dispatch(
                                        deliverDoctorOrder(order._id)
                                      ).then(() => {
                                        dispatch(
                                          getAllOrdersByStatus({
                                            orderStatus,
                                          })
                                        );
                                      })
                                    }
                                  />
                                </IconButton>
                              </Tooltip>

                              {order.orderStatus === "shipped" || (
                                <Tooltip title={<h5>Cancel</h5>}>
                                  <IconButton style={{ cursor: "pointer" }}>
                                    {/* cancel btn */}
                                    <DoDisturbOnIcon
                                      onClick={() =>
                                        dispatch(
                                          cancelDoctorOrder(order._id)
                                        ).then(() => {
                                          dispatch(
                                            getAllOrdersByStatus({
                                              orderStatus,
                                            })
                                          );
                                        })
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          )}

                        {order.orderStatus === "delivered" ||
                          order.orderStatus === "pending" ||
                          order.orderStatus === "shipped" || (
                            <Tooltip title={<h5>Remove</h5>}>
                              <IconButton className="btn-delete">
                                <DeleteForeverIcon
                                  onClick={() =>
                                    dispatch(deleteOrder(order._id)).then(
                                      () => {
                                        dispatch(
                                          getAllOrdersByStatus({
                                            orderStatus,
                                          })
                                        );
                                      }
                                    )
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                          )}

                        <Tooltip title={<h5>Details</h5>}>
                          <IconButton style={{ cursor: "pointer" }}>
                            <VisibilityIcon
                              onClick={() => handleOpenDetails(order._id)}
                            />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* -----pgination-----  */}
              <Pagination
                count={10}
                page={page}
                onChange={(_, page) => setpage(page)}
              />
            </div>
          </>
        </div>

        <div>
          {/* order details */}
          <Modal
            open={open}
            onClose={handleCloseDetails}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                style={{
                  padding: "18px",
                  borderRadius: "8px 8px 0 0",
                  color: "#fff",
                  textAlign: "center",
                  background: "black",
                }}
                id="modal-modal-title"
                variant="h4"
                component="h2"
              >
                Order Details
              </Typography>
              <Grid container spacing={2}>
                <Grid xs={5}>
                  <div
                    style={{
                      padding: "32px",
                    }}
                  >
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      <span
                        style={{
                          display: "inline-block",
                          marginRight: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        Order Date :{" "}
                      </span>{" "}
                      {orderDetails?.orderDate}
                    </Typography>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      <span
                        style={{
                          display: "inline-block",
                          marginRight: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        Order Status :{" "}
                      </span>

                      {orderDetails?.orderStatus}
                    </Typography>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      <span
                        style={{
                          display: "inline-block",
                          marginRight: "8px",
                          fontWeight: "bold",
                        }}
                      >
                        Total Price :{" "}
                      </span>
                      {orderDetails?.totalPrice}
                    </Typography>

                    {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Products : {orderDetails?.products.map((p) => )}
              </Typography> */}

                    <div style={{ display: "flex", gap: "18px" }}>
                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <span
                          style={{
                            display: "inline-block",
                            marginRight: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          Address :{" "}
                        </span>
                      </Typography>

                      <div style={{ flexGrow: 1 }}>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Name:
                          </span>
                          {orderDetails?.deliverInfo?.address?.addressName}
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            governorate:
                          </span>
                          {orderDetails?.deliverInfo?.address?.governorate}
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            city:
                          </span>
                          {orderDetails?.deliverInfo?.address?.city}
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            street:
                          </span>
                          {orderDetails?.deliverInfo?.address?.street}
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            building:
                          </span>
                          {orderDetails?.deliverInfo?.address?.building}
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                          <span
                            style={{
                              background: "#0d6efd",
                              minWidth: "150px",
                              display: "inline-block",
                              color: "#fff",
                              padding: "2px 6px",
                              marginRight: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            details:
                          </span>
                          {orderDetails?.deliverInfo?.address?.details}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid xs={7}>
                  {orderDetails?.orderStatus === "shipped" && (
                    <div
                      style={{ display: "flex", gap: "18px", padding: "32px" }}
                    >
                      <Typography id="modal-modal-description">
                        <span
                          style={{
                            display: "inline-block",
                            fontWeight: "bold",
                          }}
                        >
                          Deliver Date & Time:
                        </span>
                      </Typography>

                      <form
                        onSubmit={formik.handleSubmit}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: "60%",
                          margin: "0 auto",
                          gap: "18px",
                        }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="date"
                            name="date"
                            onChange={(value) =>
                              formik.setFieldValue("date", value)
                            }
                            value={formik.values.date}
                            renderInput={(params) => (
                              <TextField name="date" {...params} />
                            )}
                          />

                          <DesktopTimePicker
                            label="Time"
                            name="time"
                            onChange={(value) =>
                              formik.setFieldValue("time", value)
                            }
                            value={formik.values.time}
                            renderInput={(params) => (
                              <TextField name="time" {...params} />
                            )}
                          />
                        </LocalizationProvider>
                        <Button type="submit" variant="contained" color="info">
                          Change
                        </Button>
                      </form>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Modal>

          {/* order shipping */}
          <Modal
            open={openShip}
            onClose={handleCloseShip}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                style={{
                  padding: "18px",
                  borderRadius: "8px 8px 0 0",
                  color: "#fff",
                  textAlign: "center",
                  background: "black",
                }}
                id="modal-modal-title"
                variant="h4"
                component="h2"
              >
                Order Shipping Info
              </Typography>
              <div
                style={{
                  padding: "32px",
                }}
              >
                <form
                  onSubmit={formik.handleSubmit}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "60%",
                    margin: "0 auto",
                    gap: "18px",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="date"
                        name="date"
                        onChange={(value) =>
                          formik.setFieldValue("date", value)
                        }
                        value={formik.values.date}
                        renderInput={(params) => (
                          <TextField name="date" {...params} />
                        )}
                      />

                      <DesktopTimePicker
                        label="Time"
                        name="time"
                        onChange={(value) =>
                          formik.setFieldValue("time", value)
                        }
                        value={formik.values.time}
                        renderInput={(params) => (
                          <TextField name="time" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>

                  <Button type="submit" variant="contained" color="success">
                    Ship
                  </Button>
                </form>
              </div>
            </Box>
          </Modal>
        </div>
      </>
    </div>
  );
}

export default OrderList;
